import { observer } from "mobx-react";
import RmaPageStore, { IRmaAction, RMA_ACTION_TYPE } from "../../../stores/rma-page-store";
import { Button } from "../../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";
import IconResendStatusEmail
	from "../../../../../../components/icons/icon-resend-status-email/icon-resend-status-email";
import IconReject from "../../../../../../components/icons/icon-reject/icon-reject";
import IconDiscard from "../../../../../../components/icons/icon-discard/icon-discard";
import ResendStatusEmailButton from "../../resend-status-email/resend-status-email-button/resend-status-email-button";
import { useState } from "react";
import { ButtonIcon } from "../../../../../../components/inputs/button-icon/button-icon";
import IconMore from "../../../../../../components/icons/icon-more/icon-more";

import './more-actions-menu.scss';
import { IRMAEmailLog } from "../../../rma-types";
import IconManuallyResolveIssue
	from "../../../../../../components/icons/icon-manually-resolve-issue/icon-manually-resolve-issue";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import rmsMixpanelStore from "../../../../../../stores/rms-mixpanel-store";

interface IProps {
    rma: RmaPageStore;
    setCurrentRmaAction: (action: IRmaAction | null) => void;
    setCurrentEmailLog: (emailLog: IRMAEmailLog) => void;
}

export const MoreActionsMenu: React.FC<IProps> = observer(({ rma, setCurrentRmaAction, setCurrentEmailLog }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-returns-rma-card';

    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const reopenRmaAction = rma.reopenAction();
    const rejectRmaAction = rma.rejectAction();
    const cancelRmaAction = rma.cancelAction();
    const resolveErrorsAction = rma.resolveErrorsAction();

    const applyAction = (action: IRmaAction) => {

		switch (action.type) {
			case RMA_ACTION_TYPE.CANCEL:
				rmsMixpanelStore.trackEvent(`d&_cancel_button`);
				break;
			case RMA_ACTION_TYPE.REJECT:
				rmsMixpanelStore.trackEvent(`d&_reject_button`);
				break;
			case RMA_ACTION_TYPE.REOPEN:
				rmsMixpanelStore.trackEvent(`d&_reopen_button`);
				break;
			case RMA_ACTION_TYPE.RESOLVE_ERRORS:
				rmsMixpanelStore.trackEvent(`d&_resolve_errors_button`);
				break;
			default:
				break;
		}

        setCurrentRmaAction(action);
        setIsExpanded(false);
    }

    const currentEmailLogCallback = (emailLog: IRMAEmailLog) => {
        setCurrentEmailLog(emailLog); 
        setIsExpanded(false);
    }

    const IconDiscardGrey = () => (<IconDiscard color="var(--color-neutral-3)" />);
    
    const onIconMoreClick = () => {
        rmsMixpanelStore.trackEvent('d&_bottom_three_dots');
        setIsExpanded(!isExpanded);
    }

    return (
        <>
            <ButtonIcon Component={IconMore} onClick={onIconMoreClick} />
            {isExpanded &&
                <div className="more-actions-menu">
                    {cancelRmaAction &&
                        <Button
                            variant={BUTTON_VARIANTS.Default}
                            leftIcon={IconDiscardGrey}
                            text={getTranslation(cancelRmaAction.name, scope)}
                            onClick={() => applyAction(cancelRmaAction)}
                        />
                    }

                    {reopenRmaAction &&
                        <Button
                            variant={BUTTON_VARIANTS.Default}
                            leftIcon={IconResendStatusEmail}
                            text={getTranslation(reopenRmaAction.name, scope)}
                            onClick={() => applyAction(reopenRmaAction)}
                        />
                    }

                    {rejectRmaAction &&
                        <Button
                            variant={BUTTON_VARIANTS.Default}
                            leftIcon={IconReject}
                            text={getTranslation(rejectRmaAction.name, scope)}
                            onClick={() => applyAction(rejectRmaAction)}
                        />
                    }

                    {rma.emailLogList.length > 0 && <ResendStatusEmailButton rma={rma} setCurrentEmailLog={currentEmailLogCallback} />}
                    {(resolveErrorsAction && rma.errorListStore?.lastUnresolvedShortError) &&
                        <Button
                            leftIcon={IconManuallyResolveIssue}
                            variant={BUTTON_VARIANTS.Default}
                            text={getTranslation('MANUALLY_RESOLVE_ISSUE', scope)}
                            onClick={() => applyAction(resolveErrorsAction)}
                        />
                    }
                </div>
            }
        </>
    );
});

export default MoreActionsMenu;